<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>check</v-icon>Aprobar movilidad</v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container grid-list-md style="min-width:100%" class="py-0">
          <v-layout wrap row>
            <v-flex xs12 class="text-xs-center">
              <h3>¿Está seguro de aprobar la movilidad?</h3>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" :loading="loading" @click="aprobarRechazar(0)">
          <v-icon>clear</v-icon> Rechazar
        </v-btn>
        <v-btn color="success" :loading="loading" @click="aprobarRechazar(1)">
          <v-icon>check</v-icon> Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import Retiro from "../components/Retiro.vue";
import IncorporacionPasante from "../components/IncorporacionPasante.vue";
export default {
  components: {
    Retiro,
    IncorporacionPasante
  },
  mixins: [validate],
  data() {
    return {
      user: this.$storage.get("user"),
      dialog: false,
      form: {},
      movilidad: {},
      loading: false
    };
  },
  async mounted() {
    this.$bus.$on("openDialogAprobarMovilidadPasante", item => {
      this.movilidad = item;
      this.dialog = true;
    });
  },
  methods: {
    async aprobarRechazar(tipo) {
      if (tipo == 1) {
        try {
          let data_movilidad = {
            id_movilidad: this.movilidad.id,
            id_tipo_justificacion: this.movilidad.id_tipo_justificacion,
            id_usuario: this.user.id
          };
          let res = await this.$service.graphql({
            query: `
              query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_movilidad_pasante('${JSON.stringify(
                data_movilidad
              ).replace(/"/g, '\\"')}')"){
              respuesta
              }
            }
              `
          });

          res = res.runQuery.respuesta[0].fn_aprueba_movilidad_pasante;
          let resps = res.split("|");
          let correcto = resps[0];
          if (correcto === "1") {
            this.$message.success();
          } else {
            this.$message.error(resps[1]);
          }

          this.loading = false;
          this.close();
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          let resps = [];
          let res;
          let correcto = true;
          this.loading = true;
          let temp = this.$moment(
            this.movilidad.fecha_desde,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          res = await this.$service.graphql({
            query: `
              query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_rechaza_movilidad(${this.movilidad.id_persona}, ${this.user.id}, ${tipo}, '${temp}',null,null,null,null)"){
              respuesta
              }
            }
              `
          });

          res = res.runQuery.respuesta[0].fn_aprueba_rechaza_movilidad;
          resps = res.split("|");
          correcto = resps[0];
          if (correcto === "1") {
            this.$message.success();
          } else {
            this.$message.error(resps[1]);
          }

          this.loading = false;
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
    },
    close() {
      this.form = {};
      this.movilidad = {};
      this.$bus.$emit("closeDialogMovilidad");
      this.dialog = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/AprobarMovilidadPasante.vue